import React, { useState } from 'react';
import { ArchetypeWizard } from './components/ArchetypeWizard';
import { ProtocolDashboard } from './components/ProtocolDashboard';
import { Box, Title, Container, Grid, Text } from '@mantine/core';
import { Brain } from 'lucide-react';
import { Sidebar } from './components/Sidebar';
import { Home } from './components/Home';
import { BuildWizard } from './components/BuildWizard';
import { BuildResults } from './components/BuildResults';
import { ExploreTerminology } from './components/ExploreTerminology';
import { Methodology } from './components/Methodology';
import { SavedVectors } from './components/SavedVectors';
export function App() {
  const [showResults, setShowResults] = useState(false);
  const [userProtocol, setUserProtocol] = useState(null);
  const [activeNavItem, setActiveNavItem] = useState('home');
  const [selectedOutcomes, setSelectedOutcomes] = useState([]);
  const handleProtocolGenerated = protocol => {
    setUserProtocol(protocol);
    setShowResults(true);
  };
  const handleOutcomesPrioritized = outcomes => {
    setSelectedOutcomes(outcomes);
    setShowResults(true);
  };
  const handleReset = () => {
    setShowResults(false);
    setUserProtocol(null);
    setSelectedOutcomes([]);
  };
  const handleNavigate = item => {
    setActiveNavItem(item);
    // Reset views when navigating
    setShowResults(false);
    setUserProtocol(null);
    setSelectedOutcomes([]);
  };
  const renderContent = () => {
    switch (activeNavItem) {
      case 'vector':
        return !showResults ? <ArchetypeWizard onProtocolGenerated={handleProtocolGenerated} data-id="element-0" /> : <ProtocolDashboard protocol={userProtocol} onReset={handleReset} data-id="element-1" />;
      case 'build':
        return !showResults ? <BuildWizard onOutcomesPrioritized={handleOutcomesPrioritized} data-id="element-2" /> : <BuildResults selectedOutcomes={selectedOutcomes} onReset={handleReset} data-id="element-3" />;
      case 'explore':
        return <ExploreTerminology data-id="element-4" />;
      case 'saved':
        return <SavedVectors data-id="element-5" />;
      case 'methodology':
        return <Methodology data-id="element-6" />;
      case 'home':
      default:
        return <Home onNavigate={handleNavigate} data-id="element-7" />;
    }
  };
  return <Box className="min-h-screen w-full bg-slate-50 text-slate-900 flex" data-id="element-8">
      <Grid gutter={0} className="min-h-screen w-full" data-id="element-9">
        <Grid.Col span={{
        base: 0,
        sm: 3,
        md: 2
      }} className="hidden sm:block p-0" data-id="element-10">
          <div className="h-full" data-id="element-11">
            <Sidebar activeItem={activeNavItem} onNavigate={handleNavigate} data-id="element-12" />
          </div>
        </Grid.Col>
        <Grid.Col span={{
        base: 12,
        sm: 9,
        md: 10
      }} data-id="element-13">
          <Container size="lg" className="py-8" data-id="element-14">
            <header className="flex items-center justify-center mb-8 sm:hidden" data-id="element-15">
              <Brain className="text-emerald-600 mr-3" size={32} data-id="element-16" />
              <Title order={1} className="text-3xl font-bold text-slate-800" data-id="element-17">
                Nutrivector
              </Title>
            </header>
            {renderContent()}
          </Container>
        </Grid.Col>
      </Grid>
    </Box>;
}